module.exports = __webpack_public_path__ + "img/full_service_graphic.38ebda5d.svg";